/**
 * PocketFiler - French (fr) Translation File
 * Complete translation - all keys from en.js
 */

const fr = {
  "nav.login": "Connexion",
  "nav.signup": "Commencer",
  "nav.logout": "Déconnexion",
  "nav.dashboard": "Tableau de bord",
  "nav.virtualOffices": "Bureaux virtuels",
  "nav.clients": "Clients",
  "nav.deals": "Transactions",
  "nav.documents": "Documents",
  "nav.messages": "Messages",
  "nav.settings": "Paramètres",
  "nav.invoices": "Factures",
  "nav.templates": "Modèles",
  "nav.tasks": "Tâches",
  "nav.meetings": "Réunions",
  "nav.analytics": "Analytique",
  "landing.badge": "Plateforme de transactions avec IA",
  "landing.hero.title": "Concluez des transactions importantes dans n'importe quelle langue",
  "landing.hero.titleHighlight": "avec l'IA",
  "landing.hero.subtitle": "PocketFiler aide les entreprises et les particuliers à réaliser des transactions documentaires à haute confiance – du commerce mondial aux ventes de voitures locales et polices d'assurance – avec la traduction IA, les flux de documents et les Salles de transaction pour chaque deal.",
  "landing.hero.cta.start": "Commencer gratuitement",
  "landing.hero.cta.demo": "Voir comment ça marche",
  "landing.useCases.title": "Conçu pour le commerce mondial, les services locaux et les grandes transactions personnelles",
  "landing.useCases.subtitle": "Que vous importiez des marchandises de l'étranger ou vendiez votre voiture en ville, PocketFiler vous donne les outils pour conclure en toute confiance.",
  "landing.useCases.globalTrade.title": "Commerce mondial et fabrication",
  "landing.useCases.globalTrade.desc": "Trouvez et travaillez avec des fournisseurs étrangers, collectez des documents de conformité et négociez dans des Salles de transaction avec traduction en temps réel.",
  "landing.useCases.insurance.title": "Assurance, prêts et services professionnels",
  "landing.useCases.insurance.desc": "Invitez les clients à télécharger des pièces d'identité, relevés et formulaires dans leur langue, puis suivez chaque document et message dans des Bureaux virtuels.",
  "landing.useCases.realEstate.title": "Immobilier et transactions de propriété",
  "landing.useCases.realEstate.desc": "Guidez les acheteurs et locataires à travers les demandes, divulgations et contrats en plusieurs langues, le tout dans une seule Salle de transaction par deal.",
  "landing.useCases.vehicle.title": "Ventes privées de véhicules et d'actifs",
  "landing.useCases.vehicle.desc": "Utilisez les Salles de transaction et les contrats générés par IA pour gérer les actes de vente et la documentation des voitures, équipements et autres objets de valeur.",
  "landing.audience.title": "Conçu pour les particuliers et les équipes",
  "landing.audience.individuals.title": "Pour les particuliers",
  "landing.audience.individuals.bullet1": "Concluez des transactions importantes ponctuelles comme l'achat de voitures, d'équipements ou d'objets de valeur avec des dossiers clairs.",
  "landing.audience.individuals.bullet2": "Utilisez des liens simples et sécurisés pour télécharger des documents et consulter des contrats depuis votre téléphone.",
  "landing.audience.individuals.bullet3": "Conservez tous les messages, fichiers et brouillons de contrats pour chaque transaction en un seul endroit, même après sa conclusion.",
  "landing.audience.teams.title": "Pour les entreprises et équipes",
  "landing.audience.teams.bullet1": "Créez des Bureaux virtuels pour chaque ligne de service (assurance, immobilier, prêts, importations) avec des listes personnalisées.",
  "landing.audience.teams.bullet2": "Invitez des clients dans n'importe quelle langue à télécharger des documents, signer des contrats et communiquer dans les Salles de transaction.",
  "landing.audience.teams.bullet3": "Donnez à votre équipe un espace de travail partagé avec des chronologies, des résumés IA et un historique complet pour chaque transaction.",
  "landing.howItWorks.title": "Comment PocketFiler fonctionne pour toute transaction",
  "landing.howItWorks.subtitle": "Quatre fonctionnalités puissantes qui travaillent ensemble pour vous aider à conclure des deals plus rapidement et avec moins de friction.",
  "landing.howItWorks.concierge.title": "Concierge IA",
  "landing.howItWorks.concierge.desc": "Votre assistant IA apprend votre activité, configure les bons Bureaux virtuels et crée des listes de documents pour chaque type de transaction.",
  "landing.howItWorks.translation.title": "Traduction automatique",
  "landing.howItWorks.translation.desc": "Les messages et le contenu clé sont traduits instantanément entre les parties, pour que les acheteurs, vendeurs et clients puissent communiquer dans leur langue.",
  "landing.howItWorks.documents.title": "Documents intelligents",
  "landing.howItWorks.documents.desc": "Les clients téléchargent des documents depuis leur téléphone ; l'IA extrait les champs clés, vérifie la qualité et signale les problèmes avant qu'ils ne ralentissent le deal.",
  "landing.howItWorks.dealRooms.title": "Salles de transaction et contrats",
  "landing.howItWorks.dealRooms.desc": "Chaque transaction obtient une salle dédiée avec une chronologie, des messages, des documents et des brouillons de contrats générés par IA que vous pouvez réviser et finaliser.",
  "landing.cta.title": "Prêt à conclure votre prochaine transaction ?",
  "landing.cta.subtitle": "Rejoignez les entreprises et particuliers qui utilisent PocketFiler pour gérer les transactions importantes en toute confiance.",
  "landing.cta.button": "Créer un compte gratuit",
  "landing.footer.tagline": "Les transactions importantes simplifiées.",
  "language.picker.title": "Choisissez votre langue",
  "language.picker.subtitle": "Nous vous montrerons toutes les instructions, messages et contrats dans cette langue. Les autres peuvent choisir leur propre langue ; l'IA s'occupe de la traduction pour vous.",
  "language.picker.continue": "Continuer",
  "language.picker.playSample": "Écouter un exemple",
  "language.picker.playing": "Lecture en cours...",
  "language.picker.confirmation": "Vous avez sélectionné {language}. Nous vous montrerons tout dans cette langue. Les autres parties peuvent choisir leur propre langue ; PocketFiler traduit les messages, documents et contrats pour que tout le monde comprenne.",
  "language.toast.saved": "Langue enregistrée ! Pour la changer, allez dans Paramètres de votre profil.",
  "language.confirm.title": "Confirmez votre langue",
  "language.confirm.subtitle": "Cette langue sera utilisée pour toute l'interface, les messages et les contrats.",
  "language.confirm.change": "Changer de langue",
  "language.confirm.continue": "Continuer avec",
  "language.confirm.chineseNote": "Note : Vous avez sélectionné le chinois simplifié (简体中文). Si vous préférez le chinois traditionnel, veuillez modifier votre sélection.",
  "auth.login.title": "Bienvenue",
  "auth.login.subtitle": "Connectez-vous à votre compte PocketFiler",
  "auth.login.email": "E-mail",
  "auth.login.password": "Mot de passe",
  "auth.login.submit": "Connexion",
  "auth.login.noAccount": "Pas de compte ?",
  "auth.login.signupLink": "Inscrivez-vous",
  "auth.login.error": "E-mail ou mot de passe invalide",
  "auth.signup.title": "Créez votre compte",
  "auth.signup.subtitle": "Commencez à conclure des deals dans n'importe quelle langue",
  "auth.signup.name": "Nom complet",
  "auth.signup.email": "E-mail",
  "auth.signup.password": "Mot de passe",
  "auth.signup.confirmPassword": "Confirmer le mot de passe",
  "auth.signup.companyName": "Nom de l'entreprise",
  "auth.signup.companyType": "Type d'industrie",
  "auth.signup.submit": "Créer un compte",
  "auth.signup.hasAccount": "Déjà un compte ?",
  "auth.signup.loginLink": "Connectez-vous",
  "auth.signup.terms": "En vous inscrivant, vous acceptez nos Conditions d'utilisation et notre Politique de confidentialité.",
  "dashboard.title": "Tableau de bord",
  "dashboard.welcome": "Bienvenue, {name}",
  "dashboard.aiSummary.title": "Résumé IA",
  "dashboard.aiSummary.generating": "Génération du résumé...",
  "dashboard.stats.totalDeals": "Total des transactions",
  "dashboard.stats.activeDeals": "Transactions actives",
  "dashboard.stats.totalClients": "Total des clients",
  "dashboard.stats.documentsProcessed": "Documents traités",
  "dashboard.recentDeals.title": "Transactions récentes",
  "dashboard.recentDeals.viewAll": "Voir tout",
  "dashboard.recentDeals.empty": "Pas encore de transactions. Créez votre première transaction pour commencer.",
  "dashboard.recentClients.title": "Clients récents",
  "dashboard.recentClients.viewAll": "Voir tout",
  "dashboard.recentClients.empty": "Pas encore de clients. Invitez votre premier client pour commencer.",
  "dashboard.quickActions.title": "Actions rapides",
  "dashboard.quickActions.createDeal": "Créer une transaction",
  "dashboard.quickActions.inviteClient": "Inviter un client",
  "dashboard.quickActions.createOffice": "Créer un bureau virtuel",
  "offices.title": "Bureaux virtuels",
  "offices.subtitle": "Organisez votre activité par type de service",
  "offices.create": "Créer un bureau virtuel",
  "offices.empty.title": "Pas encore de bureaux virtuels",
  "offices.empty.desc": "Créez votre premier Bureau virtuel pour organiser vos transactions et clients.",
  "offices.card.clients": "{count} clients",
  "offices.card.deals": "{count} transactions",
  "offices.card.checklist": "Éléments de la liste",
  "offices.checklist": "Liste des documents",
  "offices.noChecklist": "Aucun document requis",
  "offices.dialog.title": "Créer un bureau virtuel",
  "offices.dialog.desc": "Configurez un nouvel espace de travail pour un type de service spécifique",
  "offices.dialog.name": "Nom du bureau",
  "offices.dialog.namePlaceholder": "ex : Réclamations d'assurance, Ventes immobilières",
  "offices.dialog.type": "Type de bureau",
  "offices.dialog.description": "Description",
  "offices.dialog.descriptionPlaceholder": "Décrivez ce que gère ce bureau...",
  "offices.dialog.checklist": "Liste des documents",
  "offices.dialog.checklistHelp": "Liste générée par IA des documents requis",
  "offices.dialog.addItem": "Ajouter un élément",
  "offices.dialog.generateChecklist": "Générer avec IA",
  "offices.dialog.creating": "Création...",
  "offices.dialog.create": "Créer le bureau",
  "offices.form.name": "Nom du bureau",
  "offices.form.namePlaceholder": "ex : Services d'assurance, Immobilier, etc.",
  "offices.form.description": "Description",
  "offices.form.descPlaceholder": "Quels types de transactions ce bureau gérera-t-il ?",
  "offices.form.checklistPlaceholder": "Ajouter un document requis...",
  "offices.ai.title": "Configuration assistée par IA",
  "offices.ai.desc": "Laissez notre Concierge IA vous aider à configurer le bureau virtuel parfait en posant des questions sur vos besoins professionnels.",
  "offices.ai.manual": "Configurer manuellement",
  "offices.ai.start": "Démarrer la configuration IA",
  "offices.ai.startOnboarding": "Aidez-moi à configurer mon bureau virtuel",
  "offices.ai.suggestion": "Suggestion IA",
  "offices.ai.acceptSuggestion": "Accepter et créer le bureau",
  "offices.ai.inputPlaceholder": "Tapez votre réponse...",
  "clients.title": "Clients",
  "clients.subtitle": "Gérez vos clients et invitations",
  "clients.invite": "Inviter un client",
  "clients.empty.title": "Pas encore de clients",
  "clients.empty.desc": "Invitez votre premier client pour commencer.",
  "clients.table.name": "Nom",
  "clients.table.client": "Client",
  "clients.table.contact": "Contact",
  "clients.table.office": "Bureau",
  "clients.table.language": "Langue",
  "clients.table.status": "Statut",
  "clients.table.actions": "Actions",
  "clients.status.invited": "Invité",
  "clients.status.active": "Actif",
  "clients.status.completed": "Terminé",
  "clients.dialog.title": "Inviter un nouveau client",
  "clients.dialog.name": "Nom du client",
  "clients.dialog.email": "Adresse e-mail",
  "clients.dialog.phone": "Numéro de téléphone",
  "clients.dialog.office": "Bureau virtuel",
  "clients.dialog.language": "Langue préférée",
  "clients.dialog.sending": "Envoi de l'invitation...",
  "clients.dialog.send": "Envoyer l'invitation",
  "clients.toast.invited": "Invitation envoyée à {name}",
  "clients.toast.deleted": "Client supprimé",
  "clients.toast.linkCopied": "Lien d'invitation copié dans le presse-papiers",
  "clients.invite.step1Title": "Inviter un nouveau client",
  "clients.invite.step2Title": "Aperçu du message d'invitation",
  "clients.invite.step3Title": "Invitation envoyée !",
  "clients.invite.step1Desc": "Entrez les coordonnées du client",
  "clients.invite.step2Desc": "Révisez et personnalisez le message d'invitation",
  "clients.invite.step3Desc": "Partagez le lien d'invitation avec votre client",
  "clients.invite.nameLabel": "Nom du client",
  "clients.invite.namePlaceholder": "ex : Jean Dupont",
  "clients.invite.contactMethod": "Méthode de contact",
  "clients.invite.phone": "Numéro de téléphone",
  "clients.invite.customNote": "Note personnalisée",
  "clients.invite.customNotePlaceholder": "Instructions spéciales pour ce client...",
  "clients.invite.previewMessage": "Aperçu du message",
  "clients.invite.aiGenerated": "Message d'invitation généré par IA",
  "clients.invite.messagePreview": "Aperçu du message",
  "clients.invite.messageEditHint": "Vous pouvez modifier ce message avant l'envoi",
  "clients.invite.documentsRequested": "Documents demandés",
  "clients.invite.regenerate": "Régénérer le message",
  "clients.invite.sendInvite": "Envoyer l'invitation",
  "clients.invite.linkCreated": "Lien d'invitation créé !",
  "clients.invite.linkCopiedToClipboard": "Le lien a été copié dans votre presse-papiers",
  "clients.invite.shareLink": "Partagez ce lien avec votre client par e-mail, SMS ou en personne",
  "clients.invite.inviteAnother": "Inviter un autre",
  "clients.invite.success": "Client invité !",
  "clients.invite.linkCopied": "Lien d'invitation copié !",
  "clients.invite.yourAgent": "Votre agent",
  "clients.invite.defaultOffice": "Notre Bureau",
  "deals.title": "Transactions",
  "deals.subtitle": "Suivez et gérez vos transactions",
  "deals.create": "Créer une transaction",
  "deals.empty.title": "Pas encore de transactions",
  "deals.empty.desc": "Créez votre première transaction pour commencer.",
  "deals.search": "Rechercher des transactions...",
  "deals.filter.all": "Toutes les transactions",
  "deals.filter.active": "Actives",
  "deals.filter.pending": "En attente",
  "deals.filter.closed": "Terminées",
  "deals.column.draft": "Brouillon",
  "deals.column.active": "Actives",
  "deals.column.pending": "En attente",
  "deals.column.closed": "Terminées",
  "deals.card.documents": "{count} documents",
  "deals.card.messages": "{count} messages",
  "deals.dialog.title": "Créer une nouvelle transaction",
  "deals.dialog.dealTitle": "Titre de la transaction",
  "deals.dialog.dealTitlePlaceholder": "ex : Achat de véhicule - Honda Civic 2023",
  "deals.dialog.client": "Client",
  "deals.dialog.office": "Bureau virtuel",
  "deals.dialog.type": "Type de transaction",
  "deals.dialog.notes": "Notes",
  "deals.dialog.notesPlaceholder": "Ajoutez des notes sur cette transaction...",
  "deals.dialog.creating": "Création...",
  "deals.dialog.create": "Créer la transaction",
  "dealRoom.back": "Retour aux transactions",
  "dealRoom.readOnly.title": "Lecture seule",
  "dealRoom.readOnly.closedMessage": "Cette transaction a été clôturée. La Salle de transaction est maintenant en lecture seule pour référence et audit.",
  "dealRoom.readOnly.cancelledMessage": "Cette transaction a été annulée. La Salle de transaction est maintenant en lecture seule pour référence et audit.",
  "dealRoom.tabs.messages": "Messages",
  "dealRoom.tabs.documents": "Documents",
  "dealRoom.tabs.contract": "Contrat",
  "dealRoom.timeline.title": "Chronologie des activités",
  "dealRoom.timeline.empty": "Pas encore d'activité",
  "dealRoom.details.title": "Détails de la transaction",
  "dealRoom.details.notes": "Notes",
  "dealRoom.details.type": "Type",
  "dealRoom.details.documents": "Documents",
  "dealRoom.details.messages": "Messages",
  "dealRoom.aiSummary.title": "Résumé IA",
  "dealRoom.aiSummary.generating": "Génération du résumé...",
  "dealRoom.messages.empty": "Pas encore de messages. Commencez la conversation.",
  "dealRoom.messages.placeholder": "Tapez un message...",
  "dealRoom.messages.send": "Envoyer",
  "dealRoom.messages.sending": "Envoi...",
  "dealRoom.messages.showOriginal": "Afficher l'original",
  "dealRoom.messages.showTranslation": "Afficher la traduction",
  "dealRoom.messages.translatedFrom": "Traduit de {language}",
  "dealRoom.messages.suggestReply": "Suggérer une réponse",
  "dealRoom.documents.empty": "Aucun document téléchargé pour le moment.",
  "dealRoom.documents.upload": "Télécharger un document",
  "dealRoom.documents.uploading": "Téléchargement...",
  "dealRoom.documents.analyze": "Analyser",
  "dealRoom.documents.analyzing": "Analyse...",
  "dealRoom.documents.download": "Télécharger",
  "dealRoom.documents.delete": "Supprimer",
  "dealRoom.documents.pending": "Analyse en attente",
  "dealRoom.documents.analyzed": "Analysé",
  "dealRoom.documents.aiAnalysis": "Analyse IA du document",
  "dealRoom.documents.type": "Type de document",
  "dealRoom.documents.confidence": "Confiance",
  "dealRoom.documents.summary": "Résumé",
  "dealRoom.documents.issues": "Problèmes",
  "dealRoom.contract.empty.title": "Aucun contrat généré",
  "dealRoom.contract.empty.desc": "Générez un brouillon de contrat IA pour cette transaction.",
  "dealRoom.contract.generate": "Générer un brouillon de contrat",
  "dealRoom.contract.regenerate": "Régénérer le contrat",
  "dealRoom.contract.generating": "Génération...",
  "dealRoom.contract.aiLabel": "Brouillon de contrat généré par IA",
  "dealRoom.contract.language": "Langue",
  "dealRoom.contract.copy": "Copier",
  "dealRoom.contract.copied": "Copié dans le presse-papiers",
  "dealRoom.contract.type": "Type de contrat",
  "dealRoom.contract.generated": "Généré",
  "dealRoom.contract.languages": "Langues",
  "dealRoom.contract.status": "Statut",
  "dealRoom.contract.notice": "Analyse IA du document : Une ou plusieurs clauses n'ont pas d'équivalent direct entre les langues sélectionnées. Nous avons utilisé un langage descriptif. Veuillez examiner attentivement ces sections et confirmer avec l'autre partie si nécessaire.",
  "dealRoom.contract.dialog.title": "Générer un brouillon de contrat",
  "dealRoom.contract.dialog.desc": "L'IA générera un contrat bilingue basé sur les détails de la transaction.",
  "dealRoom.contract.dialog.disclaimer": "Ceci est un brouillon généré par IA à des fins de révision. Faites-le examiner par un professionnel juridique avant de signer.",
  "dealRoom.contract.dialog.type": "Type de contrat",
  "dealRoom.contract.dialog.languages": "Langues",
  "dealRoom.contract.dialog.languagesHelp": "Sélectionnez deux langues pour votre contrat bilingue. Toutes les langues de niveau 1 sont entièrement prises en charge.",
  "dealRoom.contract.dialog.primary": "Primaire",
  "dealRoom.contract.dialog.secondary": "Secondaire",
  "dealRoom.contract.dialog.terms": "Conditions spéciales",
  "dealRoom.contract.dialog.termsPlaceholder": "Ajoutez des conditions ou clauses spéciales...",
  "dealRoom.contract.dialog.generate": "Générer le contrat",
  "dealRoom.contract.dialog.generating": "Génération...",
  "dealRoom.status.change": "Changer le statut",
  "dealRoom.status.dialog.title": "Changer le statut de la transaction",
  "dealRoom.status.dialog.from": "De",
  "dealRoom.status.dialog.to": "À",
  "dealRoom.status.dialog.reason": "Raison (optionnel)",
  "dealRoom.status.dialog.reasonPlaceholder": "Pourquoi changez-vous le statut ?",
  "dealRoom.status.dialog.confirm": "Confirmer le changement",
  "dealRoom.status.dialog.changing": "Changement...",
  "dealRoom.status.toast.changed": "Statut changé en {status}",
  "dealRoom.upgrade.title": "Passer à Business",
  "dealRoom.upgrade.desc": "La génération de contrats nécessite un plan Business.",
  "dealRoom.upgrade.features": "Avec Business, vous obtenez :",
  "dealRoom.upgrade.feature1": "Brouillons de contrats générés par IA",
  "dealRoom.upgrade.feature2": "Analyse avancée des documents",
  "dealRoom.upgrade.feature3": "Support prioritaire",
  "dealRoom.upgrade.button": "Mettre à niveau maintenant",
  "settings.title": "Paramètres",
  "settings.subtitle": "Gérez votre compte et votre organisation",
  "settings.tabs.profile": "Profil",
  "settings.tabs.organization": "Organisation",
  "settings.profile.title": "Paramètres du profil",
  "settings.profile.subtitle": "Gérez vos informations personnelles",
  "settings.profile.name": "Nom complet",
  "settings.profile.email": "E-mail",
  "settings.profile.emailNote": "L'e-mail ne peut pas être modifié",
  "settings.profile.language": "Langue préférée",
  "settings.profile.languageHelp": "Toute l'interface, les messages et les contrats seront affichés dans cette langue.",
  "settings.profile.save": "Enregistrer les modifications",
  "settings.profile.saving": "Enregistrement...",
  "settings.profile.saved": "Profil mis à jour",
  "settings.org.title": "Paramètres de l'organisation",
  "settings.org.subtitle": "Gérez les informations de votre entreprise",
  "settings.org.name": "Nom de l'organisation",
  "settings.org.type": "Type d'industrie",
  "settings.org.billingEmail": "E-mail de facturation",
  "settings.org.plan": "Plan",
  "settings.org.verification": "Statut de vérification",
  "settings.org.save": "Enregistrer les modifications",
  "settings.org.saving": "Enregistrement...",
  "settings.org.saved": "Organisation mise à jour",
  "settings.org.noOrg": "Organisation non trouvée",
  "invite.language.title": "Choisissez votre langue",
  "invite.language.subtitle": "Nous vous montrerons toutes les instructions dans votre langue.",
  "invite.welcome.title": "Bienvenue chez",
  "invite.welcome.subtitle": "Nous sommes prêts à recevoir vos documents.",
  "invite.welcome.time": "5-10 minutes",
  "invite.welcome.timeLabel": "Temps estimé",
  "invite.welcome.secure": "Sécurisé et Gratuit",
  "invite.welcome.secureDesc": "Vos documents sont cryptés. Ce service est gratuit pour vous.",
  "invite.welcome.start": "Commencer le téléchargement",
  "invite.documents.needed": "Documents nécessaires",
  "invite.upload.title": "Télécharger un document",
  "invite.upload.dragDrop": "Glissez-déposez un fichier ici, ou cliquez pour sélectionner",
  "invite.upload.or": "ou",
  "invite.upload.takePhoto": "Images",
  "invite.upload.browse": "Fichiers",
  "invite.upload.uploading": "Téléchargement...",
  "invite.upload.analyzing": "Vérification du document...",
  "invite.upload.success": "Téléchargé avec succès",
  "invite.upload.next": "Document suivant",
  "invite.upload.finish": "Tout vérifier",
  "invite.upload.skip": "Passer pour l'instant",
  "invite.upload.progress": "Progression",
  "invite.complete.title": "Terminé !",
  "invite.complete.subtitle": "Vos documents ont été soumis avec succès.",
  "invite.complete.message": "Nous avons reçu tous vos documents. Nous vous contacterons bientôt.",
  "invite.complete.summary": "Documents soumis",
  "invite.complete.securityNote": "Vos documents sont stockés en toute sécurité et ne seront accessibles qu'au personnel autorisé.",
  "invite.chat.title": "Chat avec votre agent",
  "invite.chat.placeholder": "Tapez un message...",
  "invite.chat.empty": "Pas encore de messages. Commencez une conversation.",
  "invite.chat.sent": "Votre message a été envoyé.",
  "invite.chat.willRespond": "Nous vous répondrons dès que possible.",
  "invite.chat.sending": "Envoi...",
  "invite.error.title": "Lien invalide ou expiré",
  "invite.error.message": "Ce lien d'invitation n'est plus valide. Veuillez contacter l'expéditeur pour un nouveau lien.",
  "common.loading": "Chargement...",
  "common.save": "Enregistrer",
  "common.cancel": "Annuler",
  "common.delete": "Supprimer",
  "common.edit": "Modifier",
  "common.create": "Créer",
  "common.close": "Fermer",
  "common.dismiss": "Ignorer",
  "common.confirm": "Confirmer",
  "common.back": "Retour",
  "common.next": "Suivant",
  "common.previous": "Précédent",
  "common.of": "sur",
  "common.search": "Rechercher",
  "common.filter": "Filtrer",
  "common.sort": "Trier",
  "common.viewAll": "Voir tout",
  "common.refresh": "Actualiser",
  "common.retry": "Réessayer",
  "common.yes": "Oui",
  "common.no": "Non",
  "common.or": "ou",
  "common.and": "et",
  "common.optional": "optionnel",
  "common.required": "requis",
  "status.draft": "Brouillon",
  "status.active": "Active",
  "status.pending": "En attente",
  "status.pending_documents": "Documents en attente",
  "status.pending_signature": "Signature en attente",
  "status.on_hold": "En pause",
  "status.closed": "Terminée",
  "status.cancelled": "Annulée",
  "error.generic": "Une erreur s'est produite. Veuillez réessayer.",
  "error.network": "Erreur réseau. Veuillez vérifier votre connexion.",
  "error.unauthorized": "Vous n'êtes pas autorisé à effectuer cette action.",
  "error.notFound": "La ressource demandée n'a pas été trouvée.",
  "error.validation": "Veuillez vérifier votre saisie et réessayer.",
  "error.serverError": "Erreur serveur. Veuillez réessayer plus tard.",
  "success.saved": "Modifications enregistrées avec succès.",
  "success.created": "Créé avec succès.",
  "success.deleted": "Supprimé avec succès.",
  "success.sent": "Envoyé avec succès.",
  "success.uploaded": "Téléchargé avec succès.",
  "time.justNow": "À l'instant",
  "time.minutesAgo": "il y a {count} minutes",
  "time.hoursAgo": "il y a {count} heures",
  "time.daysAgo": "il y a {count} jours",
  "time.today": "Aujourd'hui",
  "time.yesterday": "Hier",
  "dealRoom.notFound": "Transaction non trouvée",
  "dealRoom.loading": "Chargement de la transaction...",
  "dealRoom.conversation.title": "Conversation de la transaction",
  "dealRoom.conversation.you": "Vous",
  "dealRoom.conversation.client": "Client",
  "dealRoom.messages.hideOriginal": "Masquer l'original",
  "dealRoom.messages.original": "Original ({language})",
  "dealRoom.messages.disabled": "Messages désactivés pour ce statut",
  "dealRoom.messages.aiSuggest": "Réponse suggérée par IA",
  "dealRoom.documents.title": "Documents",
  "dealRoom.documents.uploadDisabled": "Téléchargement désactivé",
  "dealRoom.documents.pendingAnalysis": "Analyse en attente",
  "dealRoom.documents.uploadFirst": "Télécharger le premier document",
  "dealRoom.documents.uploadHelp": "Téléchargez des documents pour l'analyse IA",
  "dealRoom.documents.uploadDisabledHelp": "Le téléchargement de documents est désactivé pour ce statut",
  "dealRoom.documents.analyzeWithAI": "Analyser avec IA",
  "dealRoom.documents.notAnalyzed": "Pas encore analysé",
  "dealRoom.documents.notAnalyzedHelp": "Lancez l'analyse IA pour extraire le type de document, les champs et obtenir des informations",
  "dealRoom.documents.analyzeDocument": "Analyser le document",
  "dealRoom.documents.extractedFields": "Champs extraits",
  "dealRoom.documents.issuesDetected": "Problèmes détectés",
  "dealRoom.documents.preview": "Aperçu",
  "dealRoom.documents.uploaded": "Téléchargé",
  "dealRoom.documents.deleteConfirm": "Êtes-vous sûr de vouloir supprimer ce document ?",
  "dealRoom.onHold.message": "Cette transaction est en pause. Le téléchargement de documents est désactivé. Vous pouvez toujours envoyer des messages pour la coordination.",
  "dealRoom.pendingSignature.message": "Le contrat est prêt à être signé. Le téléchargement de documents est désactivé jusqu'à ce que le contrat soit signé ou annulé.",
  "dealRoom.status.current": "actuel",
  "dealRoom.status.finalWarning": "C'est un statut final. La transaction ne peut pas être rouverte après cette action.",
  "dealRoom.contract.purchaseAgreement": "Contrat d'achat",
  "dealRoom.contract.purchaseAgreementDesc": "Contrat d'achat standard",
  "dealRoom.contract.noContract": "Pas encore de contrat",
  "dealRoom.contract.noContractDesc": "Générez un brouillon de contrat alimenté par IA basé sur les détails et documents de votre transaction.",
  "dealRoom.contract.notAvailable": "La génération de contrats n'est pas disponible pour les transactions {status}.",
  "dealRoom.contract.locked": "La génération de contrats est verrouillée en attente de signature.",
  "dealRoom.contract.requiresPlan": "Nécessite le plan Business Starter",
  "dealRoom.toast.dealUpdated": "Transaction mise à jour",
  "dealRoom.toast.statusChanged": "Statut de la transaction changé en {status}",
  "dealRoom.toast.statusFailed": "Échec du changement de statut",
  "dealRoom.toast.contractGenerated": "Brouillon de contrat généré avec succès",
  "dealRoom.toast.contractCopied": "Contrat {language} copié dans le presse-papiers",
  "dealRoom.toast.messageFailed": "Échec de l'envoi du message",
  "dealRoom.toast.suggestionFailed": "Échec de la génération de suggestion",
  "dealRoom.toast.documentUploaded": "Document téléchargé",
  "dealRoom.toast.uploadFailed": "Échec du téléchargement",
  "dealRoom.toast.analysisComplete": "Analyse IA du document terminée",
  "dealRoom.toast.analysisFailed": "Échec de l'analyse IA",
  "dealRoom.toast.documentDeleted": "Document supprimé",
  "dealRoom.toast.deleteFailed": "Échec de la suppression",
  "dealRoom.details.created": "Créé",
  "dealRoom.details.addNotes": "Ajouter des notes sur la transaction...",
  "onboarding.brand": "PocketFiler",
  "onboarding.skip": "Passer pour l'instant",
  "onboarding.badge": "Configuration alimentée par IA",
  "onboarding.welcome": "Bienvenue, {name} !",
  "onboarding.welcomeGeneric": "Bienvenue !",
  "onboarding.subtitle": "Configurons votre espace de travail PocketFiler. Parlez de votre entreprise à notre Concierge IA, et nous configurerons tout pour vous.",
  "onboarding.step1": "Décrivez votre entreprise et vos besoins",
  "onboarding.step2": "L'IA suggère votre configuration",
  "onboarding.step3": "Commencez à gérer les transactions",
  "onboarding.concierge.title": "Concierge IA",
  "onboarding.toast.officeCreated": "Bureau virtuel créé !",
  "auth.signup.accountType": "Type de compte",
  "auth.signup.passwordTooShort": "Le mot de passe doit contenir au moins 8 caractères",
  "auth.signup.passwordsDoNotMatch": "Les mots de passe ne correspondent pas",
  "auth.signup.success": "Compte créé avec succès !",
  "captions.connecting": "Connexion...",
  "captions.disable": "Désactiver les sous-titres",
  "captions.enable": "Activer les sous-titres",
  "captions.error.connect": "Échec de la connexion au service de sous-titres",
  "captions.error.toggle": "Échec de l'activation/désactivation des sous-titres",
  "captions.language": "Langue des sous-titres",
  "captions.live": "En direct",
  "captions.off": "Sous-titres désactivés",
  "captions.on": "Sous-titres activés",
  "captions.original": "Original",
  "captions.translated": "Traduit",
  "captions.translating": "Traduction en cours...",
  "clients.joined.empty.desc": "Vous n'avez rejoint aucune organisation pour l'instant. Demandez-leur de vous inviter à leur espace de travail PocketFiler.",
  "clients.joined.empty.title": "Aucune organisation rejointe",
  "clients.nav.joinedOrgs": "Organisations rejointes",
  "clients.nav.myClients": "Mes clients",
  "clients.table.joinedDate": "Date d'adhésion",
  "clients.table.organization": "Organisation",
  "common.backToHome": "Retour à l'accueil",
  "common.deleteConfirmDesc": "Cette action ne peut pas être annulée. Cela supprimera définitivement l'élément et les données de nos serveurs.",
  "common.deleteConfirmTitle": "Êtes-vous absolument sûr ?",
  "common.noResults": "Aucun résultat trouvé",
  "connect.createAccount": "Créer un compte gratuit",
  "connect.dealCreated": "Transaction créée avec succès",
  "connect.error.invalid": "Lien de connexion invalide",
  "connect.error.invalidDesc": "Ce lien de connexion est invalide ou a expiré.",
  "connect.error.server": "Une erreur s'est produite",
  "connect.error.serverDesc": "Veuillez réessayer plus tard.",
  "connect.infoUnauth": "Cette personne utilise PocketFiler pour gérer des transactions et documents multilingues en toute sécurité.",
  "connect.joinOffice": "Rejoindre le bureau virtuel",
  "connect.loggedInAs": "Connecté en tant que",
  "connect.login": "Se connecter",
  "connect.startDeal": "Démarrer une transaction",
  "connect.titleAuth": "Vous vous connectez avec",
  "connect.titleUnauth": "Se connecter avec",
  "connect.typeOrg": "Organisation",
  "connect.typePerson": "Personne",
  "contacts.actions.call": "Appeler",
  "contacts.actions.email": "Email",
  "contacts.actions.message": "Envoyer un message dans l'app",
  "contacts.actions.noEmail": "Aucune adresse email",
  "contacts.actions.noPhone": "Aucun numéro de téléphone",
  "contacts.actions.sms": "SMS",
  "contacts.actions.title": "Contact {name}",
  "contacts.actions.whatsapp": "WhatsApp",
  "contacts.dialog.name": "Nom du contact",
  "contacts.dialog.title": "Ajouter un nouveau contact",
  "contacts.empty.desc": "Ajoutez votre premier contact pour commencer.",
  "contacts.empty.title": "Aucun contact pour l'instant",
  "contacts.invite": "Ajouter un contact",
  "contacts.invite.customNotePlaceholder": "Notes particulières concernant ce contact...",
  "contacts.invite.nameLabel": "Nom du contact",
  "contacts.invite.shareLink": "Partagez ce lien avec votre contact par email, SMS ou en personne",
  "contacts.invite.step1Desc": "Entrez les informations du contact",
  "contacts.invite.step1Title": "Ajouter un nouveau contact",
  "contacts.subtitle": "Gérez vos contacts et invitations",
  "contacts.table.contact": "Contact",
  "contacts.title": "Contacts",
  "contacts.toast.deleted": "Contact supprimé",
  "contacts.toast.invited": "Contact ajouté : {name}",
  "contacts.toast.linkCopied": "Lien copié dans le presse-papiers",
  "dashboard.quickActions.inviteContact": "Ajouter un contact",
  "dashboard.recentContacts.empty": "Aucun contact pour l'instant. Invitez votre premier contact pour commencer.",
  "dashboard.recentContacts.title": "Contacts récents",
  "dashboard.recentContacts.viewAll": "Voir tout",
  "dashboard.stats.totalContacts": "Total des contacts",
  "dealRoom.contract.analysisWarning": "Certains documents n'ont pas encore été analysés. L'analyse IA améliore la précision du contrat.",
  "dealRoom.conversation.colleague": "Collègue",
  "dealRoom.details.clients": "Clients",
  "dealRoom.documents.previewNotAvailable": "Aperçu non disponible. Téléchargement...",
  "dealRoom.incomingCall.accept": "Accepter",
  "dealRoom.incomingCall.decline": "Refuser",
  "dealRoom.incomingCall.inProgress": "Appel en cours",
  "dealRoom.incomingCall.started": "{name} a démarré un appel",
  "dealRoom.messages.connecting": "Connexion au chat...",
  "dealRoom.messages.connectionError": "Impossible de se connecter à la conversation.",
  "dealRoom.pendingSignature.loading": "Chargement du statut de signature...",
  "dealRoom.pendingSignature.signedWaitingOthers": "Signé avec succès. En attente des autres participants.",
  "dealRoom.readOnly.completedMessage": "Cette transaction a été finalisée avec succès. Le Deal Room est maintenant en lecture seule à des fins de référence et d'audit.",
  "dealRoom.signature.signed": "Signé",
  "dealRoom.signature.signedByYou": "Signé par vous",
  "dealRoom.signature.success": "Contrat signé avec succès !",
  "dealRoom.signaturesList.clients": "Clients",
  "dealRoom.signaturesList.dealOwner": "Propriétaire de la transaction",
  "dealRoom.signaturesList.pending": "En attente",
  "dealRoom.signaturesList.signedOn": "Signé le",
  "dealRoom.signaturesList.title": "Signatures",
  "dealRoom.signaturesList.viewSignatures": "Voir les signatures",
  "dealRoom.signedByAll.addPayment": "Ajouter un paiement",
  "dealRoom.signedByAll.message": "Signé par tous les participants. Procéder au paiement.",
  "dealRoom.timeline.createdBy": "par {name}",
  "deals.tabs.all": "Toutes les transactions",
  "deals.tabs.my": "Mes transactions",
  "deals.validation.clientRequired": "Veuillez sélectionner au moins un client",
  "deals.validation.notesLength": "Les notes doivent contenir 200 caractères maximum",
  "deals.validation.titleLength": "Le titre doit contenir 100 caractères maximum",
  "deals.validation.titleRequired": "Le titre de la transaction est requis",
  "documents.readAloud.analyzeFirst": "Analysez d'abord ce document pour le lire à voix haute.",
  "documents.readAloud.error": "Échec de la lecture à voix haute",
  "documents.readAloud.title": "Lecture à voix haute",
  "landing.cta.secondary": "Voir un exemple de Deal Room",
  "landing.hero.trust": "Plan gratuit. Aucune carte de crédit requise. 11 langues prises en charge.",
  "landing.socialProof": "Approuvé par plus de 500 entreprises dans 40 pays",
  "landing.useCases.personal.desc": "Finalisez des transactions importantes ponctuelles comme des véhicules, équipements ou propriétés avec des dossiers clairs, des contrats IA et des liens sécurisés simples pour le partage de documents.",
  "landing.useCases.personal.title": "Transactions personnelles de grande valeur",
  "landing.useCases.professional.desc": "Invitez vos clients à télécharger des documents avec l'assistance IA, suivez chaque interaction dans des Bureaux Virtuels Sécurisés, et générez des contrats numériques bilingues—le tout depuis un seul espace de travail.",
  "landing.useCases.professional.subtitle": "Assurance, Immobilier, Crédit",
  "landing.useCases.professional.title": "Services professionnels",
  "livekit.call": "Appel",
  "livekit.connecting": "Connexion...",
  "livekit.error.connect": "Échec de la connexion à l'appel. Veuillez réessayer.",
  "livekit.error.connection": "Erreur de connexion. Veuillez vérifier votre réseau et réessayer.",
  "livekit.error.permission": "Vous n'avez pas l'autorisation de rejoindre cet appel.",
  "livekit.hint": "Parlez dans ce Deal au lieu de changer d'application.",
  "livekit.inCall": "En appel",
  "livekit.joinCall": "Rejoindre l'appel",
  "livekit.leaveCall": "Quitter l'appel",
  "livekit.participant": "participant",
  "livekit.participants": "participants",
  "messages.readAloud.error": "Échec de la lecture à voix haute",
  "messages.readAloud.title": "Lecture à voix haute",
  "nav.companyProfile": "Profil de l'entreprise",
  "nav.contacts": "Contacts",
  "nav.directory": "Répertoire",
  "nav.products": "Produits",
  "offices.card.contacts": "{count} contacts",
  "pwa.banner.install": "Installer",
  "pwa.banner.subtitle": "Accès plus rapide, fonctionne hors ligne",
  "pwa.banner.title": "Téléchargez l'app PocketFiler",
  "pwa.firefox.hint": "Dans Firefox, recherchez l'icône d'installation (⊕) dans la barre d'adresse pour ajouter cette app à votre bureau.",
  "pwa.installApp": "Installer l'app",
  "pwa.installed": "App installée avec succès !",
  "pwa.ios.description": "Ajoutez PocketFiler à votre écran d'accueil pour une meilleure expérience :",
  "pwa.ios.gotIt": "Compris",
  "pwa.ios.inToolbar": "dans la barre d'outils de votre navigateur",
  "pwa.ios.inTopRight": "en haut à droite",
  "pwa.ios.shareButton": "le bouton Partager",
  "pwa.ios.step1": "Appuyez sur",
  "pwa.ios.step2": "Faites défiler vers le bas et appuyez sur",
  "pwa.ios.step3": "Appuyez sur",
  "pwa.ios.title": "Installer PocketFiler",
  "pwa.iosHint": "Appuyez sur l'icône Partager et \"Ajouter à l'écran d'accueil\" pour installer PocketFiler.",
  "pwa.opera.chromeHint": "ouvrez cette page, puis cliquez sur l'icône d'installation dans la barre d'adresse",
  "pwa.opera.desktopNotSupported": "Opera desktop ne prend pas en charge l'installation PWA. Pour installer PocketFiler en tant qu'application, veuillez l'ouvrir dans Google Chrome ou Microsoft Edge.",
  "pwa.opera.edgeHint": "ouvrez cette page, puis cliquez sur l'icône d'installation (⊕) dans la barre d'adresse",
  "pwa.opera.mobileAddPage": "Ajouter la page à",
  "pwa.opera.mobileDescription": "Appuyez sur l'icône + en bas d'Opera, ou utilisez le menu ci-dessous :",
  "pwa.opera.mobileHomeScreen": "l'écran d'accueil",
  "pwa.opera.mobileStep1": "Appuyez sur",
  "pwa.opera.mobileStep1b": "l'icône plus (+) dans la barre du bas d'Opera",
  "pwa.opera.mobileStep2": "Ou appuyez sur",
  "pwa.opera.mobileTitle": "Installer PocketFiler dans Opera",
  "pwa.opera.recommendedBrowsers": "Utilisez plutôt :",
  "pwa.opera.title": "Non disponible dans Opera",
  "qr.clickToExpand": "Cliquez pour afficher en plein écran",
  "qr.copied": "Copié !",
  "qr.copyLink": "Copier le lien",
  "qr.description": "Montrez ce code à vos clients ou partenaires. Quand ils le scannent, ils peuvent se connecter avec vous et démarrer une transaction en quelques secondes.",
  "qr.download": "Télécharger",
  "qr.generate": "Générer un code QR",
  "qr.linkCopied": "Lien copié dans le presse-papiers",
  "qr.primaryLanguage": "Langue principale",
  "qr.regenerate": "Réinitialiser",
  "qr.regenerated": "Code QR régénéré. Les anciens liens ne sont plus valides.",
  "qr.scanInstructions": "Scannez ce QR avec PocketFiler ou n'importe quel scanner QR pour vous connecter.",
  "qr.scanToConnect": "Scanner pour se connecter",
  "qr.share": "Partager",
  "qr.title": "Partagez votre QR PocketFiler",
  "qr.yourLink": "Votre lien de connexion :",
  "recording.completed": "Enregistrement terminé",
  "recording.confirmDelete": "Supprimer cet enregistrement ?",
  "recording.delete": "Supprimer",
  "recording.deleted": "Enregistrement supprimé",
  "recording.download": "Télécharger",
  "recording.error.delete": "Échec de la suppression de l'enregistrement",
  "recording.error.noCall": "Aucun appel actif. Veuillez d'abord rejoindre l'appel.",
  "recording.error.start": "Échec du démarrage de l'enregistrement",
  "recording.error.stop": "Échec de l'arrêt de l'enregistrement",
  "recording.failed": "Échec de l'enregistrement",
  "recording.noRecordings": "Aucun enregistrement pour l'instant",
  "recording.play": "Lire",
  "recording.playback": "Lecture de l'enregistrement",
  "recording.processing": "Traitement...",
  "recording.start": "Enregistrer",
  "recording.started": "Enregistrement démarré",
  "recording.stop": "Arrêter",
  "recording.stopped": "Enregistrement arrêté. Traitement...",
  "recording.viewRecordings": "Voir les enregistrements",
  "schedule.button": "Planifier",
  "schedule.cancel": "Annuler",
  "schedule.chooseDateTime": "Veuillez choisir la date et l'heure",
  "schedule.create": "Planifier",
  "schedule.created": "Planifié",
  "schedule.dateTime": "Date et heure",
  "schedule.description": "Choisissez une date et une heure. Vous pourrez rejoindre l'appel au moment prévu.",
  "schedule.title": "Planifier un appel ou un enregistrement",
  "schedule.type": "Type",
  "schedule.typeCall": "Appel",
  "schedule.typeRecording": "Enregistrement",
  "schedule.upcoming": "Prochainement planifié",
  "settings.profile.accountType": "Type de compte",
  "settings.profile.accountTypeHelp": "Choisissez le type qui vous correspond le mieux",
  "settings.tabs.sharing": "Partager QR",
  "support.askAI": "Demander à l'IA",
  "support.availableTimes": "Créneaux disponibles",
  "support.booked": "Appel planifié avec succès !",
  "support.bookingConfirmed": "Parfait, j'ai planifié votre appel pour {time}. Vous recevrez une confirmation avec le lien d'appel. Puis-je vous aider avec autre chose ?",
  "support.bookingError": "Échec de la réservation. Veuillez réessayer.",
  "support.clearChat": "Effacer la conversation",
  "support.error": "Échec de l'envoi du message. Veuillez réessayer.",
  "support.inYourTime": "dans votre heure locale",
  "support.inputPlaceholder": "Tapez votre question...",
  "support.openChat": "Ouvrir le support IA",
  "support.scheduleCall": "Planifier un appel avec le support",
  "support.scheduleTitle": "Planifier un appel de support",
  "support.slotsError": "Échec du chargement des créneaux disponibles.",
  "support.subtitle": "Posez toute question sur PocketFiler",
  "support.title": "Support IA",
  "support.welcome": "Bonjour ! Je suis l'assistant IA PocketFiler. Je peux vous aider avec :\\n\\n- Créer et gérer des transactions\\n- Envoyer des documents à signer\\n- Utiliser la fonction de connexion QR\\n- Inviter des clients\\n- Toute autre question sur PocketFiler\\n\\nComment puis-je vous aider aujourd'hui ?",
  "support.yourTimezone": "Votre fuseau horaire",
  "validation.emailInvalid": "Format d'email invalide",
  "validation.emailRequired": "L'email est requis",
  "validation.nameRequired": "Le nom est requis",
  "validation.nameTooLong": "Le nom doit contenir moins de 50 caractères",
  "validation.noteTooLong": "La note doit contenir moins de 200 caractères",
  "validation.phoneInvalid": "Numéro de téléphone invalide (10-15 chiffres)",
  "validation.phoneRequired": "Le numéro de téléphone est requis",
  "deals.column.cancelled": "Annulé",
  "deals.column.completed": "Terminé",
  "deals.column.disputed": "Contesté",
  "deals.column.escrow_funded": "Séquestre financé",
  "deals.column.on_hold": "En attente",
  "deals.column.pending_documents": "Documents en attente",
  "deals.column.pending_payment": "Paiement en attente",
  "deals.column.pending_signature": "Signature en attente",
  "deals.column.release_requested": "Libération demandée",
  "dashboard.actions.addClient": "Ajouter un client",
  "dashboard.actions.all": "Tout",
  "dashboard.actions.createContract": "Créer un contrat",
  "dashboard.actions.createInvoice": "Créer une facture",
  "dashboard.actions.customize": "Personnaliser",
  "dashboard.actions.newDeal": "Nouvelle affaire",
  "dashboard.actions.scheduleMeeting": "Planifier une réunion",
  "dashboard.actions.uploadDocument": "Télécharger un document",
  "dashboard.actions.viewAll": "Voir tout",
  "dashboard.briefing.default": "Rien d'urgent pour le moment. Votre espace de travail est en bon état.",
  "dashboard.briefing.title": "Briefing quotidien",
  "dashboard.empty.activity": "Aucune activité récente.",
  "dashboard.empty.deals": "Aucune affaire pour le moment. Créez votre première affaire pour voir le pipeline.",
  "dashboard.empty.documents": "Tous les documents sont à jour.",
  "dashboard.empty.meetings": "Aucune réunion à venir.",
  "dashboard.empty.tasks": "Aucune tâche ouverte.",
  "dashboard.greeting.afternoon": "Bon après-midi",
  "dashboard.greeting.evening": "Bonsoir",
  "dashboard.greeting.morning": "Bonjour",
  "dashboard.greeting.subtitle": "Voici ce qui se passe dans votre espace de travail.",
  "dashboard.stats.documents": "Documents",
  "dashboard.stats.invoicesDue": "Factures échues",
  "dashboard.stats.meetingsComing": "Réunions à venir",
  "dashboard.stats.tasksDue": "Tâches échues",
  "dashboard.stats.unreadMessages": "Messages non lus",
  "dashboard.widgets.dealPipeline": "Pipeline des affaires",
  "dashboard.widgets.documentsAttention": "Documents nécessitant une attention",
  "dashboard.widgets.gettingStarted": "Commencer",
  "dashboard.widgets.quickActions": "Actions rapides",
  "dashboard.widgets.recentActivity": "Activité récente",
  "dashboard.widgets.tasks": "Tâches",
  "dashboard.widgets.upcomingMeetings": "Réunions à venir",
  "dashboard.steps.createDeal": "Créez votre première transaction",
  "dashboard.steps.addClient": "Ajouter un client",
  "dashboard.steps.uploadDocument": "Téléverser un document",
  "dashboard.steps.scheduleMeeting": "Planifier une réunion",
  "dashboard.steps.createInvoice": "Créer une facture",
  "dashboard.steps.addLogo": "Ajouter votre logo",
  "dashboard.steps.complete": "terminé",
  "dashboard.time.overdue": "En retard",
  "dashboard.time.today": "Aujourd'hui",
  "dashboard.time.tomorrow": "Demain",
  "dashboard.time.noDate": "Pas de date",
  "dashboard.docReason.sent": "Envoyé, en attente de réponse",
  "dashboard.docReason.notAnalyzed": "Pas encore analysé",
  "dashboard.docReason.draft": "Brouillon, non finalisé",
  "dashboard.docReason.needsReview": "Révision nécessaire",
  "docViewer.notFound": "Document introuvable",
  "docViewer.previewUnavailable": "Aperçu non disponible pour ce type de fichier",
  "docViewer.aiAnalysis": "Analyse AI",
  "docViewer.documentType": "Type de document",
  "docViewer.summary": "Résumé",
  "docViewer.extractedFields": "Champs extraits",
  "docViewer.issues": "Problèmes",
  "docViewer.tags": "Étiquettes",
  "docViewer.noPreviousVersions": "Aucune version précédente",
  "docViewer.noActivity": "Aucune activité pour le moment",
  "auth.forgotPassword.title": "Réinitialisez votre mot de passe",
  "guestSign.loading": "Chargement du contrat...",
  "guestSign.unableToLoad": "Impossible de charger le contrat",
  "guestSign.signed": "Contrat signé",
  "guestSign.createOwn": "Souhaitez-vous créer et gérer vos propres contrats ?",
  "guestSign.secureSign": "Signature sécurisée",
  "meeting.ended": "Cette réunion est terminée",
  "meeting.cancelled": "Réunion annulée",
  "meeting.notFound": "Réunion introuvable",
  "meeting.joiningAs": "Connexion en tant que",
  "meeting.yourName": "Votre nom *",
  "meeting.emailOptional": "Email (optionnel)",
  "notFound.title": "Page introuvable",
  "notFound.dashboard": "Aller au tableau de bord",
  "notFound.home": "Accueil",
  "auth.resetPassword.invalidLink": "Lien invalide",
  "auth.resetPassword.title": "Définir un nouveau mot de passe",
  "templates.category": "Catégorie",
  "templates.legal": "Juridique",
  "templates.sales": "Ventes",
  "templates.services": "Services",
  "templates.finance": "Finance",
  "templates.library": "Bibliothèque de modèles",
  "templates.libraryDesc": "Modèles de documents prêts à utiliser pour votre entreprise",
  "templates.noDefault": "Aucun modèle par défaut ne correspond à votre recherche.",
  "templates.noCustom": "Aucun modèle personnalisé trouvé",
  "templates.delete": "Supprimer le modèle",
  "templates.cancel": "Annuler",
  "uploadRequest.notFound": "Demande introuvable",
  "uploadRequest.error": "Une erreur s'est produite",
  "uploadRequest.errorDesc": "Veuillez réessayer plus tard ou contacter la personne qui a envoyé cette demande.",
  "uploadRequest.uploaded": "Documents téléchargés !",
  "uploadRequest.title": "Demande de téléchargement de document",
  "uploadRequest.fileTypes": "PDF, images, documents Word - max 25MB",
  "verify.verifying": "Vérification de votre email...",
  "verify.success": "Email vérifié !",
  "verify.signIn": "Se connecter",
  "verify.alreadyVerified": "Déjà vérifié",
  "verify.invalidLink": "Lien invalide",
  "verify.backToLogin": "Retour à la connexion",
  "documents.documents": "Documents",
  "documents.allStatus": "Tous les statuts",
  "documents.newFolder": "Nouveau dossier",
  "documents.clear": "Effacer",
  "documents.noDocumentsYet": "Aucun document pour le moment",
  "documents.status": "Statut",
  "documents.type": "Type",
  "documents.uploadedBy": "Téléchargé par",
  "documents.previewNotAvailable": "Aperçu non disponible",
  "documents.aiAnalysis": "Analyse IA",
  "documents.documentType": "Type de document",
  "documents.summary": "Résumé",
  "documents.extractedFields": "Champs extraits",
  "documents.issues": "Problèmes",
  "documents.notYetAnalyzed": "Pas encore analysé",
  "documents.details": "Détails",
  "documents.size": "Taille",
  "documents.date": "Date",
  "documents.mimeType": "Type MIME",
  "documents.noTags": "Aucune étiquette",
  "documents.changeStatus": "Modifier le statut",
  "documents.versionHistory": "Historique des versions",
  "documents.noPreviousVersions": "Aucune version précédente",
  "documents.activityLog": "Journal d'activité",
  "documents.noActivityRecordedYet": "Aucune activité enregistrée pour le moment",
  "documents.uploadDocuments": "Télécharger des documents",
  "documents.dragAndDropFiles": "Glissez-déposez les fichiers ou cliquez pour parcourir. PDF, images, documents Word pris en charge.",
  "documents.shareDocument": "Partager le document",
  "documents.done": "Terminé",
  "documents.emailOptional": "E-mail (optionnel)",
  "documents.leaveEmptyToJust": "Laissez vide pour simplement générer un lien",
  "documents.messageOptional": "Message (optionnel)",
  "documents.cancel": "Annuler",
  "documents.requestDocuments": "Demander des documents",
  "documents.sendASecureUpload": "Envoyer un lien de téléchargement sécurisé à un client par e-mail.",
  "documents.clientEmail": "E-mail du client *",
  "documents.clientName": "Nom du client",
  "documents.requestedDocuments": "Documents demandés *",
  "documents.renameFolder": "Renommer le dossier",
  "documents.selectADestinationFolder": "Sélectionnez un dossier de destination.",
  "documents.deleteDocument": "Supprimer le document ?",
  "settings.individual": "Particulier",
  "settings.business": "Entreprise",
  "settings.buyer": "Acheteur",
  "settings.seller": "Vendeur",
  "settings.chooseYourPreferredTheme": "Choisissez votre thème préféré",
  "settings.light": "Clair",
  "settings.dark": "Sombre",
  "settings.system": "Système",
  "settings.manufacturing": "Fabrication",
  "settings.insurance": "Assurance",
  "settings.realEstate": "Immobilier",
  "settings.automotive": "Automobile",
  "settings.importexport": "Import/Export",
  "settings.other": "Autre",
  "settings.brandingWhitelabel": "Image de marque et marque blanche",
  "settings.customizeThePocketfilerExperience": "Personnalisez l'expérience PocketFiler pour vos clients.",
  "settings.organizationLogo": "Logo de l'organisation",
  "settings.provideADirectLink": "Fournissez un lien direct vers votre logo PNG transparent ou SVG.",
  "settings.primaryThemeColor": "Couleur de thème principale",
  "settings.selectAHexColor": "Sélectionnez un code couleur hexadécimal pour représenter les accents principaux de votre marque.",
  "settings.accentHoverColor": "Couleur d'accent/survol",
  "settings.selectAHexColor1": "Sélectionnez une couleur hexadécimale pour les états de survol, les surlignages et les éléments d'accent.",
  "settings.customDomain": "Domaine personnalisé",
  "settings.ensureYouConfigureA": "Assurez-vous de configurer un enregistrement CNAME pointant vers pocketfiler.com.",
  "settings.cancellationScheduled": "Annulation programmée",
  "settings.yourLastPaymentFailed": "Votre dernier paiement a échoué. Veuillez mettre à jour votre méthode de paiement pour conserver l'accès.",
  "settings.chooseYourPlan": "Choisissez votre plan",
  "settings.monthly": "Mensuel",
  "settings.save20": "Économisez 20%",
  "settings.current": "Actuel",
  "settings.popular": "Populaire",
  "settings.contactSales": "Contacter les ventes",
  "settings.googleCalendar": "Google Calendar",
  "settings.syncYourPocketfilerMeetings": "Synchronisez vos réunions PocketFiler avec Google Calendar",
  "settings.settingsPageErrorDebug": "Erreur de page des paramètres (débogage)",
  "invoices.createInvoice": "Créer une facture",
  "invoices.createANewInvoice": "Créer une nouvelle facture pour un client",
  "invoices.selectClient": "Sélectionner le client",
  "invoices.dueDate": "Date d'échéance",
  "invoices.clientName": "Nom du client",
  "invoices.clientEmail": "E-mail du client",
  "invoices.lineItems": "Éléments de ligne",
  "invoices.description": "Description",
  "invoices.qty": "Qté",
  "invoices.price": "Prix",
  "invoices.tax": "Taxe %",
  "invoices.total": "Total",
  "invoices.subtotal": "Sous-total :",
  "invoices.discount": "Remise :",
  "invoices.tax1": "Taxe :",
  "invoices.total1": "Total :",
  "invoices.notesOptional": "Notes (optionnel)",
  "invoices.invoices": "Factures",
  "invoices.manageAndTrackYour": "Gérez et suivez vos factures",
  "invoices.totalInvoiced": "Total facturé",
  "invoices.paid": "Payé",
  "invoices.outstanding": "En attente",
  "invoices.totalInvoices": "Total des factures",
  "invoices.allInvoices": "Toutes les factures",
  "invoices.myInvoices": "Mes Factures",
  "invoices.receivedInvoices": "Factures Reçues",
  "invoices.noInvoicesYet": "Aucune facture pour le moment",
  "meetings.join": "Rejoindre",
  "meetings.end": "Terminer",
  "meetings.meetingTitle": "Titre de la Réunion",
  "meetings.date": "Date",
  "meetings.time": "Heure",
  "meetings.duration": "Durée",
  "meetings.repeat": "Répéter",
  "meetings.doesNotRepeat": "Ne se répète pas",
  "meetings.weekly": "Hebdomadaire",
  "meetings.every2Weeks": "Toutes les 2 semaines",
  "meetings.monthly": "Mensuel",
  "meetings.invitePeopleOptional": "Inviter des Personnes (optionnel)",
  "meetings.cancel": "Annuler",
  "meetings.meetings": "Réunions",
  "companyprofile.companyProfile": "Profil d'Entreprise",
  "companyprofile.manageYourBusinessProfile": "Gérez votre profil d'entreprise et votre équipe",
  "companyprofile.publicProfile": "Profil Public",
  "companyprofile.basicInformation": "Informations de Base",
  "companyprofile.essentialDetailsAboutYour": "Détails essentiels concernant votre entreprise",
  "companyprofile.companyName": "Nom de l'Entreprise",
  "companyprofile.tagline": "Slogan",
  "companyprofile.industry": "Secteur d'Activité",
  "companyprofile.companyType": "Type d'Entreprise",
  "companyprofile.description": "Description",
  "companyprofile.companyDetails": "Détails de l'Entreprise",
  "companyprofile.additionalInformationAboutYour": "Informations supplémentaires concernant votre entreprise",
  "companyprofile.yearEstablished": "Année de Création",
  "companyprofile.numberOfEmployees": "Nombre d'Employés",
  "companyprofile.certifications": "Certifications",
  "companyprofile.enterCertificationsSeparatedBy": "Saisissez les certifications séparées par des virgules",
  "companyprofile.languagesSpoken": "Langues Parlées",
  "companyprofile.shippingRegions": "Régions de Livraison",
  "companyprofile.contactInformation": "Informations de Contact",
  "companyprofile.howPotentialPartnersCan": "Comment les partenaires potentiels peuvent vous contacter",
  "companyprofile.website": "Site Web",
  "companyprofile.email": "Email",
  "companyprofile.phone": "Téléphone",
  "companyprofile.country": "Pays",
  "companyprofile.city": "Ville",
  "companyprofile.address": "Adresse",
  "companyprofile.teamMembers": "Membres de l'Équipe",
  "companyprofile.manageUsersWithinYour": "Gérez les utilisateurs au sein de votre organisation",
  "companyprofile.role": "Rôle",
  "companyprofile.admin": "Administrateur",
  "companyprofile.member": "Membre",
  "companyprofile.viewer": "Observateur",
  "companyprofile.titleOptional": "Titre (optionnel)",
  "companyprofile.name": "Nom",
  "companyprofile.title": "Titre",
  "companyprofile.status": "Statut",
  "companyprofile.actions": "Actions",
  "companyprofile.owner": "Propriétaire",
  "companyprofile.copyInviteLink": "Copier le Lien d'Invitation",
  "companyprofile.removeMember": "Supprimer le Membre",
  "companyprofile.removeTeamMember": "Supprimer le Membre de l'Équipe",
  "companyprofile.cancel": "Annuler",
  "products.productsServices": "Produits et Services",
  "products.description": "Description",
  "products.pricing": "Tarification",
  "products.price": "Prix",
  "products.unit": "Unité",
  "products.details": "Détails",
  "products.minOrderQty": "Qté Min. de Commande",
  "products.leadTime": "Délai de Livraison",
  "products.category": "Catégorie",
  "products.currency": "Devise",
  "products.leadTimeDays": "Délai de Livraison (jours)",
  "products.active": "Actif",
  "products.showInCatalog": "Afficher dans le catalogue",
  "products.cancel": "Annuler",
  "developersettings.reveal": "Révéler",
  "developersettings.copy": "Copier",
  "developersettings.hide": "Masquer",
  "developersettings.securityWarning": "Avertissement de Sécurité",
  "developersettings.neverShareThisKey": "Ne partagez jamais cette clé publiquement ou dans du code côté client",
  "developersettings.anyoneWithThisKey": "Toute personne disposant de cette clé peut lire et modifier vos données",
  "developersettings.ifCompromisedRevokeImmediately": "Si elle est compromise, révoquez-la immédiatement et générez une nouvelle clé",
  "developersettings.iUnderstandAndAccept": "Je comprends et accepte la responsabilité de la sécurité de cette clé",
  "developersettings.cancel": "Annuler",
  "developersettings.revealKey": "Révéler la Clé",
  "developersettings.accessDenied": "Accès Refusé",
  "developersettings.onlyBusinessAccountsHave": "Seuls les comptes professionnels ont accès aux Paramètres Développeur.",
  "developersettings.developerOverview": "Aperçu Développeur",
  "developersettings.manageYourApiKeys": "Gérez vos clés API et points de terminaison Webhook pour les intégrations tierces.",
  "developersettings.secretApiKeys": "Clés API Secrètes",
  "developersettings.interactiveApiDocumentationRarr": "Documentation API Interactive &rarr;",
  "developersettings.name": "Nom",
  "developersettings.key": "Clé",
  "developersettings.createdAt": "Créé le",
  "developersettings.status": "Statut",
  "developersettings.actions": "Actions",
  "developersettings.webhookEndpoints": "Points de Terminaison Webhook",
  "developersettings.url": "URL",
  "developersettings.events": "Événements",
  "developersettings.description": "Description",
  "developersettings.done": "Terminé",
  "developersettings.addWebhookEndpoint": "Ajouter un Point de Terminaison Webhook",
  "developersettings.payloadUrl": "URL de payload",
  "developersettings.eventsToSend": "Événements à envoyer",
  "developersettings.sendMeEverything": "Tout m'envoyer (*)",
  "developersettings.dealStatusChangedDealstatuschanged": "Statut d'affaire modifié (deal.status_changed)",
  "developersettings.documentUploadedDocumentuploaded": "Document téléversé (document.uploaded)",
  "developersettings.descriptionOptional": "Description (Optionnelle)",
  "analytics.noDataAvailableFor": "Aucune donnée disponible pour cette période.",
  "analytics.noDealsFound": "Aucune affaire trouvée.",
  "analytics.noClientDataAvailable": "Aucune donnée client disponible pour cette période.",
  "analytics.client": "Client",
  "analytics.invoices": "Factures",
  "analytics.revenue": "Chiffre d'affaires",
  "analytics.totalPipeline": "Pipeline total",
  "analytics.noRecentActivityFor": "Aucune activité récente pour cette période.",
  "analytics.pipelineOverview": "Vue d'ensemble du pipeline",
  "analytics.goToDeals": "Aller aux affaires",
  "analytics.analyticsDashboard": "Tableau de bord analytique",
  "analytics.trackYourBusinessPerformance": "Suivez les performances et insights de votre entreprise",
  "analytics.last7Days": "7 derniers jours",
  "analytics.last30Days": "30 derniers jours",
  "analytics.last90Days": "90 derniers jours",
  "analytics.lastYear": "Année dernière",
  "analytics.overview": "Vue d'ensemble",
  "analytics.myPerformance": "Ma performance",
  "analytics.currentDealsByStatus": "Affaires actuelles par statut",
  "analytics.revenueTrendsOverLast": "Tendances du chiffre d'affaires sur les 6 derniers mois",
  "analytics.accountsGeneratingTheMost": "Comptes générant le plus de chiffre d'affaires",
  "analytics.currentCashFlowOverview": "Vue d'ensemble du flux de trésorerie actuel",
  "analytics.latestBusinessActivitiesAnd": "Dernières activités commerciales et mises à jour",
  "compliance.complianceCenter": "Centre de conformité",
  "compliance.hsCodesTariffsSanctions": "Codes HS, tarifs, contrôle des sanctions et contrôles d'exportation",
  "compliance.hsCodeClassification": "Classification du code HS",
  "compliance.productDescription": "Description du produit",
  "compliance.tariffCalculator": "Calculateur de tarifs",
  "compliance.estimateImportDutiesBased": "Estimez les droits d'importation basés sur le code HS et la route commerciale.",
  "compliance.hsCode": "Code HS",
  "compliance.declaredValueUsd": "Valeur déclarée (USD)",
  "compliance.originCountry": "Pays d'origine",
  "compliance.destinationCountry": "Pays de destination",
  "compliance.dutyRate": "Taux de droit :",
  "compliance.totalRate": "Taux total :",
  "compliance.estDuty": "Droit estimé :",
  "compliance.totalEstCost": "Coût total estimé :",
  "compliance.tradeAgreements": "Accords commerciaux :",
  "compliance.sanctionsScreening": "Contrôle des sanctions",
  "compliance.screenEntitiesAgainstOfac": "Contrôlez les entités contre la liste OFAC SDN et les sanctions par pays.",
  "compliance.entityName": "Nom de l'entité",
  "compliance.type": "Type",
  "compliance.company": "Entreprise",
  "compliance.individual": "Individu",
  "compliance.vessel": "Navire",
  "compliance.countryOptional": "Pays (optionnel)",
  "compliance.usSanctionedCountries": "Pays sous sanctions américaines",
  "compliance.exportControlCheck": "Contrôle d'exportation",
  "compliance.aipoweredEaritarClassificationGuidance": "Guidance de classification EAR/ITAR alimentée par IA. N'est pas un conseil juridique.",
  "compliance.producttechnologyDescription": "Description du produit/technologie",
  "compliance.hsCodeOptional": "Code HS (optionnel)",
  "compliance.endUseOptional": "Utilisation finale (optionnelle)",
  "compliance.licenseRequired": "Licence requise",
  "compliance.recommendations": "Recommandations :",
  "compliance.complianceHistory": "Historique de conformité",
  "compliance.recentComplianceChecksFor": "Contrôles de conformité récents pour votre organisation.",
  "compliance.noComplianceChecksYet": "Aucun contrôle de conformité encore. Effectuez votre premier contrôle ci-dessus.",
  "intelligence.marketIntelligence": "Intelligence de marché",
  "intelligence.anonymizedTradeDataAnd": "Données commerciales anonymisées et références de la plateforme PocketFiler",
  "intelligence.demandByCategory": "Demande par catégorie",
  "intelligence.whatBuyersAreSourcing": "Ce que les acheteurs recherchent sur la plateforme (90 derniers jours)",
  "intelligence.noDemandDataYet": "Aucune donnée de demande encore. Les données se remplissent au fur et à mesure que les demandes de devis sont créées sur la plateforme.",
  "intelligence.byIndustry": "Par industrie",
  "intelligence.noSupplierDataYet": "Aucune donnée fournisseur encore.",
  "intelligence.byCountry": "Par pays",
  "intelligence.byType": "Par type",
  "intelligence.byVerification": "Par vérification",
  "intelligence.noDataYet": "Aucune donnée encore.",
  "intelligence.yourPerformanceVsPlatform": "Votre performance par rapport à la plateforme",
  "intelligence.seeHowYouStack": "Voyez comment vous vous positionnez par rapport aux moyennes de la plateforme",
  "intelligence.completeSomeDealsTo": "Complétez quelques affaires pour voir les références.",
  "virtualoffices.virtualOffices": "Bureaux virtuels",
  "virtualoffices.manageYourBrandedWorkspaces": "Gérez vos espaces de travail de marque",
  "virtualoffices.officeName": "Nom du bureau",
  "virtualoffices.industry": "Industrie",
  "virtualoffices.languagesServed": "Langues desservies",
  "virtualoffices.descriptionOptional": "Description (optionnelle)",
  "virtualoffices.documentChecklist": "Liste de vérification des documents",
  "virtualoffices.languages": "Langues",
  "tasks.tasks": "Tâches",
  "tasks.noTasksYet": "Aucune tâche encore",
  "tasks.dragTasksHere": "Glissez les tâches ici",
  "tasks.createNewTask": "Créer une nouvelle tâche",
  "tasks.descriptionOptional": "Description (Optionnelle)",
  "tasks.relatedDealOptional": "Affaire liée (Optionnelle)",
  "tasks.noDealAttached": "Aucune affaire attachée",
  "tasks.assignees": "Assignés",
  "tasks.noTeamMembersAvailable": "Aucun membre d'équipe disponible. Seuls les membres actifs peuvent être assignés.",
  "tasks.cancel": "Annuler",
  "tasks.description": "Description",
  "tasks.status": "Statut",
  "tasks.relatedDeal": "Affaire liée",
  "tasks.noAssignees": "Aucun assigné",
  "tasks.areYouAbsolutelySure": "Êtes-vous absolument certain ?",
  "events.events": "Événements",
  "events.tradeShowsWebinarsAnd": "Salons professionnels, webinaires et événements de réseautage",
  "events.createEvent": "Créer un événement",
  "events.title": "Titre",
  "events.description": "Description",
  "events.category": "Catégorie",
  "events.type": "Type",
  "events.locationUrl": "Lieu / URL",
  "events.startDateTime": "Date et heure de début",
  "events.endDateTime": "Date et heure de fin",
  "events.maxAttendeesOptional": "Nombre maximum de participants (optionnel)",
  "events.cancel": "Annuler",
  "events.allCategories": "Toutes les catégories",
  "events.noEventsFoundCreate": "Aucun événement trouvé. Créez le premier !",
  "events.featured": "À la une",
  "events.previous": "Précédent",
  "events.next": "Suivant",
  "status.pendingDocuments": "Documents en attente",
  "status.pendingSignature": "Signature en attente",
  "status.pendingPayment": "Paiement en attente",
  "status.completed": "Terminé",
  "status.updated": "Mis à jour",
  "status.onHold": "En attente",
  "activity.deal": "Affaire",
  "activity.action.analyzed": "Analysé",
  "activity.action.uploaded": "Téléchargé",
  "activity.action.downloaded": "Téléchargé",
  "activity.action.previewed": "Prévisualisé",
  "activity.action.shared": "Partagé",
  "activity.action.status_changed": "Statut modifié",
  "activity.action.updated": "Mis à jour",
  "activity.action.created": "Créé",
  "activity.action.archived": "Archivé",
  "activity.action.restored": "Restauré",
  "analytics.totalRevenue": "Chiffre d'affaires total",
  "analytics.totalDeals": "Nombre total d'affaires",
  "analytics.conversionRate": "Taux de conversion",
  "analytics.avgDealValue": "Valeur moyenne des affaires",
  "analytics.dealPipeline": "Pipeline des affaires",
  "analytics.monthlyRevenue": "Chiffre d'affaires mensuel",
  "analytics.topClientsByRevenue": "Principaux clients par chiffre d'affaires",
  "analytics.invoiceHealth": "État des factures",
  "analytics.paid": "Payé",
  "analytics.pendingPayment": "En attente de paiement",
  "companyprofile.saveProfile": "Enregistrer le profil",
  "companyprofile.makeVisible": "Rendre votre entreprise visible dans le répertoire",
  "companyprofile.tab.basicInfo": "Informations de base",
  "companyprofile.tab.details": "Détails",
  "companyprofile.tab.contact": "Contact",
  "companyprofile.tab.team": "Équipe",
  "companyprofile.tab.verification": "Vérification",
  "companyprofile.selectType": "Sélectionner le type",
  "companyprofile.describePlaceholder": "Décrivez votre entreprise, vos produits et vos services...",
  "companyprofile.industry.other": "Autre",
  "companyprofile.preview": "Aperçu",
  "companyprofile.ph.companyName": "Votre Entreprise Inc.",
  "companyprofile.ph.tagline": "Produits de qualité, portée mondiale",
  "companyprofile.ph.selectIndustry": "Sélectionner le secteur",
  "companyprofile.ph.selectSize": "Sélectionner la taille",
  "companyprofile.ph.certifications": "ISO 9001, CE, FDA (séparés par des virgules)",
  "companyprofile.ph.languages": "Français, Espagnol, Chinois",
  "companyprofile.ph.exportRegions": "Amérique du Nord, Europe, Asie",
  "companyprofile.ph.selectCountry": "Sélectionner le pays",
  "companyprofile.ph.city": "Los Angeles",
  "companyprofile.ph.teamName": "Nom du membre de l'équipe",
  "companyprofile.ph.addTitle": "Ajouter un titre...",
  "companyprofile.inviteTeamMember": "Inviter un Membre de l'Équipe",
  "companyprofile.invitationSent": "Invitation Envoyée avec Succès",
  "virtualoffices.newOffice": "Nouveau Bureau",
  "virtualoffices.createOffice": "Créer un Bureau Virtuel",
  "virtualoffices.reviewChecklist": "Examiner la Liste de Contrôle des Documents",
  "virtualoffices.setupDesc": "Configurez un nouvel espace de travail de marque pour votre entreprise",
  "virtualoffices.customizeDesc": "Personnalisez les documents dont vous avez besoin de la part des clients",
  "virtualoffices.ph.officeName": "par ex., Assurance Garcia - Polices Auto",
  "virtualoffices.ph.description": "Décrivez l'orientation de votre bureau...",
  "virtualoffices.ph.addDocument": "Ajouter un document personnalisé...",
  "virtualoffices.generating": "Génération en cours...",
  "virtualoffices.aiChecklist": "Liste de contrôle générée par IA pour",
  "virtualoffices.clients": "Clients",
  "virtualoffices.pending": "En attente",
  "virtualoffices.invite": "Inviter",
  "virtualoffices.ind.manufacturing": "Fabrication",
  "virtualoffices.ind.insurance": "Assurance",
  "virtualoffices.ind.real_estate": "Immobilier",
  "virtualoffices.ind.automotive": "Automobile",
  "virtualoffices.ind.import_export": "Import/Export",
  "virtualoffices.ind.other": "Autre",
  "messages.conversations": "Conversations",
  "messages.searchPlaceholder": "Rechercher des messages...",
  "messages.noConversations": "Aucune conversation",
  "messages.send": "Envoyer",
  "messages.selectConversation": "Sélectionner une conversation",
  "messages.selectConversationDesc": "Choisissez une conversation dans la barre latérale pour commencer à discuter",
  "messages.support": "Support",
  "messages.client": "Client",
  "messages.deal": "Affaire",
  "meetings.subtitle": "Planifier et gérer des réunions vidéo",
  "meetings.upcoming": "À venir",
  "meetings.past": "Passées",
  "meetings.schedule": "Planifier",
  "meetings.startInstant": "Démarrer instantané",
  "meetings.startNow": "Démarrer maintenant",
  "meetings.noPast": "Aucune réunion passée",
  "meetings.noUpcoming": "Aucune réunion à venir",
  "meetings.createMeeting": "Créer une réunion",
  "meetings.startInstantMeeting": "Démarrer une réunion instantanée",
  "meetings.scheduleMeeting": "Planifier une réunion",
  "meetings.scheduleDesc": "Planifiez une réunion vidéo et envoyez des invitations.",
  "meetings.invitePeople": "Inviter des personnes (optionnel)",
  "meetings.15min": "15 minutes",
  "meetings.30min": "30 minutes",
  "meetings.45min": "45 minutes",
  "meetings.allowRecording": "Autoriser l'enregistrement",
  "meetings.recordingDesc": "Permet à l'hôte d'enregistrer cette réunion",
  "meetings.waitingRoom": "Salle d'attente",
  "meetings.waitingRoomDesc": "Les participants doivent être admis par l'hôte avant de rejoindre",
  "meetings.emailPlaceholder": "email@exemple.com",
  "meetings.cancelConfirm": "Annuler cette réunion ?",
  "meetings.cancelMeeting": "Annuler la réunion",
  "documents.title": "Documents",
  "documents.viewAll": "Tout afficher",
  "documents.archived": "Archivé",
  "documents.requestDocs": "Demander des documents",
  "documents.upload": "Télécharger",
  "documents.allDocuments": "Tous les documents",
  "documents.searchPlaceholder": "Rechercher des documents...",
  "documents.addTag": "Ajouter une étiquette...",
  "documents.uploadDesc": "Glissez-déposez des fichiers ou cliquez pour parcourir. PDF, images, documents Word pris en charge.",
  "documents.emailPlaceholder": "client@exemple.com",
  "documents.shareMsgPlaceholder": "Voici le document que vous avez demandé...",
  "documents.requestDesc": "Envoyez un lien de téléchargement sécurisé à un client par e-mail.",
  "documents.namePlaceholder": "Jean Dupont",
  "documents.requestMsgPlaceholder": "Veuillez télécharger les documents suivants...",
  "documents.folderName": "Nom du dossier",
  "documents.selectDestination": "Sélectionnez un dossier de destination.",
  "documents.statusUploaded": "Téléchargé",
  "documents.statusAnalyzed": "Analysé",
  "documents.statusArchived": "Archivé",
  "documents.allTypes": "Tous les types",
  "documents.inArchive": "dans les archives",
  "templates.allTemplates": "Tous les modèles",
  "templates.editTemplate": "Modifier le modèle",
  "templates.createCustomTemplate": "Créer un modèle personnalisé",
  "templates.editDesc": "Mettez à jour votre modèle de document",
  "templates.createDesc": "Créez votre propre modèle de document réutilisable",
  "templates.ph.templateName": "ex. : NDA personnalisé",
  "templates.ph.description": "Brève description du modèle",
  "templates.ph.content": "Saisissez le contenu de votre modèle ici...",
  "templates.saving": "Enregistrement en cours...",
  "templates.creating": "Création en cours...",
  "templates.saveChanges": "Enregistrer les modifications",
  "templates.createTemplate": "Créer un modèle",
  "templates.searchPlaceholder": "Rechercher des modèles...",
  "templates.popularTemplates": "Modèles populaires",
  "templates.defaultTemplates": "Modèles par défaut",
  "templates.deleteTemplate": "Supprimer le modèle",
  "templates.preview": "Aperçu",
  "templates.description": "Description",
  "products.searchPlaceholder": "Rechercher des produits...",
  "products.ph.service": "Services de Conseil",
  "products.ph.product": "Widget Pro 3000",
  "products.selectCategory": "Sélectionner une catégorie",
  "products.ph.describe": "Décrivez votre produit ou service...",
  "products.noMatches": "Aucun résultat trouvé",
  "products.noProducts": "Aucun produit ou service pour le moment",
  "products.serviceDetails": "Détails du service",
  "products.productDetails": "Détails du produit",
  "products.inactive": "Inactif",
  "products.deleteConfirm": "Supprimer cet élément ?",
  "products.saveChanges": "Enregistrer les Modifications",
  "products.addItem": "Ajouter un Élément",
  "products.priceOnRequest": "Prix sur demande",
  "products.perUnit": "Par Unité",
  "tasks.searchPlaceholder": "Rechercher des tâches...",
  "tasks.ph.title": "ex. Examiner les documents juridiques",
  "tasks.ph.description": "Ajoutez plus de contexte à cette tâche...",
  "tasks.selectDeal": "Sélectionner une affaire à attacher",
  "tasks.noTasks": "Aucune tâche dans cette colonne",
  "tasks.deleteTask": "Supprimer la Tâche",
  "settings.tabs.branding": "Image de marque",
  "settings.tabs.payments": "Paiements",
  "settings.tabs.plan": "Forfait",
  "settings.tabs.integrations": "Intégrations",
  "settings.appearance": "Apparence",
  "settings.saveBranding": "Enregistrer l'image de marque",
  "settings.yourPlan": "Votre forfait",
  "settings.ph.logoUrl": "https://example.com/logo.png",
  "settings.ph.customDomain": "deals.yourcompany.com",
  "settings.calendarFeedGenerated": "URL du flux de calendrier générée !",
  "settings.plan.free": "Gratuit",
  "settings.plan.pro": "Pro",
  "settings.plan.smallBusiness": "Petite entreprise",
  "settings.plan.businessPro": "Entreprise Pro",
  "settings.plan.scale": "Évolutif",
  "settings.plan.enterprise": "Entreprise",
  "dealroom.meetings": "Réunions",
  "dealroom.startMeeting": "Commencer une réunion",
  "dealroom.noMeetings": "Aucune réunion n'est encore liée à cette transaction",
  "dealroom.noMeetingsDesc": "Commencez une réunion ou planifiez-en une pour débuter",
  "dealroom.failedCreateMeeting": "Échec de la création de la réunion",
  "dealroom.finalizedContract": "Contrat finalisé — Prêt pour signature",
  "dealroom.previewNotSupported": "Aperçu non pris en charge",
  "dealroom.aiMayTakeMoment": "Cela peut prendre un moment.",
  "dealroom.aiAnalysisGenerated": "L'analyse IA a été générée pour les documents suivants :",
  "dealroom.docsUnanalyzed": "Les documents suivants demeurent non analysés :",
  "dealroom.analyzingDocs": "Analyse des documents en cours...",
  "dealroom.finalizeWarning": "Cette action ne peut pas être annulée. Le statut de la transaction changera vers En attente de signature et toutes les parties pourront signer le contrat.",
  "dealroom.cannotRevert": "Impossible de revenir de l'état En attente de signature",
  "compliance.ph.productDesc": "p. ex., Boulons en acier inoxydable, M10 x 50mm...",
  "compliance.ph.exportDesc": "Décrivez le produit ou la technologie exporté(e)...",
  "compliance.select": "Sélectionner...",
  "compliance.selectCountry": "Sélectionner un pays...",
  "events.tradeShow": "Salon professionnel",
  "events.webinar": "Webinaire",
  "events.networking": "Réseautage",
  "events.conference": "Conférence",
  "events.workshop": "Atelier",
  "events.ph.title": "Titre de l'événement",
  "events.ph.location": "Adresse du lieu ou URL de réunion",
  "events.ph.maxAttendees": "Laisser vide pour illimité",
  "events.searchPlaceholder": "Rechercher des événements...",
  "events.cancelRsvp": "Annuler RSVP",
  "events.rsvp": "RSVP",
  "rfq.expired": "Expiré",
  "rfq.createRfq": "Créer une demande de devis",
  "rfq.visibility": "Visibilité",
  "rfq.public": "Public - Tous les fournisseurs peuvent voir",
  "rfq.private": "Privé - Sur invitation uniquement",
  "rfq.quantity": "Quantité",
  "rfq.unit": "Unité",
  "rfq.pieces": "Pièces",
  "rfq.kilograms": "Kilogrammes",
  "rfq.meters": "Mètres",
  "rfq.squareMeters": "Mètres carrés",
  "rfq.units": "Unités",
  "rfq.sets": "Ensembles",
  "rfq.boxes": "Boîtes",
  "rfq.deliveryLocation": "Lieu de livraison",
  "rfq.deliveryDeadline": "Date limite de livraison",
  "rfq.specialRequirements": "Exigences particulières",
  "rfq.title": "Demandes de devis",
  "rfq.subtitle": "Parcourez les demandes d'approvisionnement ou publiez la vôtre",
  "rfq.rfqsPosted": "RFQ publiés",
  "rfq.openRfqs": "RFQ ouverts",
  "rfq.quotesSent": "Devis envoyés",
  "rfq.winRate": "Taux de réussite",
  "rfq.allCategories": "Toutes les catégories",
  "rfq.noRfqsFound": "Aucun RFQ trouvé",
  "rfq.noRfqsYet": "Aucun RFQ pour le moment",
  "meetings.biweekly": "Toutes les 2 semaines",
  "meetings.cancelSeries": "Annuler toute la série",
  "meetings.cancelThisMeeting": "Annuler cette réunion",
  "meetings.nextInSeries": "Suivant dans la série",
  "nav.contractTemplates": "Contrats",
  "contracts.title": "Modèles de Contrats",
  "contracts.subtitle": "Génération de documents juridiques par IA. Sélectionnez un modèle pour commencer.",
  "documents.create": "Créer",
  "createDoc.untitledDocument": "Document sans titre",
  "createDoc.save": "Enregistrer",
  "createDoc.export": "Exporter",
  "createDoc.aiAssist": "Assistant IA",
  "createDoc.generate": "Générer",
  "createDoc.generating": "Génération...",
  "createDoc.cancel": "Annuler",
  "createDoc.translate": "Traduire",
  "createDoc.translateTitle": "Traduire le Document",
  "createDoc.translateTo": "Traduire en",
  "createDoc.translateNow": "Traduire",
  "createDoc.translating": "Traduction...",
  "createDoc.translated": "Document traduit avec succès",
  "createDoc.translateFailed": "Échec de la traduction",
  "verification.status": "Statut de Vérification",
  "verification.inProgress": "Vérification en Cours",
  "verification.getVerified": "Se Faire Vérifier",
  "verification.cancelRequest": "Annuler la Demande",
  "verification.submit": "Soumettre pour Vérification",
  "verification.submitting": "Envoi...",
  "verification.uploadDocs": "Télécharger des Documents",
  "verification.level": "Niveau de Vérification",
  "verification.selectDocType": "Sélectionnez le type de document...",
  "contracts.generate": "Générer",
  "contracts.backToTemplates": "Retour aux modèles",
  "contracts.required": "Requis",
  "contracts.modify": "Modifier",
  "contracts.finalize": "Finaliser",
  "contracts.modifyPrompt": "Dites à l\'IA comment modifier ce document :",
  "contracts.applyChanges": "Appliquer",
  "contracts.confirmDelete": "Supprimer ce brouillon ?",
  "contracts.loadFailed": "Échec du chargement",
  "contracts.generating": "Génération en cours...",
  "contracts.nda": "Accord de Confidentialité Mutuel",
  "contracts.sow": "Cahier des Charges",
  "contracts.msa": "Contrat-Cadre de Services",
  "contracts.contractor": "Contrat de Prestataire Indépendant",
  "contracts.loi": "Lettre d\'Intention",
  "templates.deleting": "Suppression...",
  "templates.noDescription": "Aucune description.",
  "templates.use": "Utiliser",
  "templates.confirmDeleteDesc": "Cela supprimera définitivement ce modèle. Cette action est irréversible.",
  "templates.lib.ndaMutual": "NDA Mutuel",
  "templates.lib.ndaMutualDesc": "Accord standard de confidentialité mutuelle pour protéger les informations entre deux parties.",
  "templates.lib.purchaseAgreement": "Contrat d\'Achat",
  "templates.lib.purchaseAgreementDesc": "Modèle standard de contrat d\'achat pour ventes B2B avec termes et conditions.",
  "templates.lib.serviceAgreement": "Contrat de Services",
  "templates.lib.serviceAgreementDesc": "Modèle de contrat de services professionnels avec portée des travaux et livrables.",
  "templates.lib.priceQuote": "Devis",
  "templates.lib.priceQuoteDesc": "Modèle professionnel de devis pour fournir des prix aux clients potentiels.",
  "templates.lib.invoice": "Facture",
  "templates.lib.invoiceDesc": "Modèle professionnel de facture pour facturer les clients et suivre les paiements.",
  "templates.lib.loi": "Lettre d\'Intention",
  "templates.lib.loiDesc": "Modèle de lettre d\'intention pour exprimer un intérêt dans un accord commercial potentiel.",
  "settings.security": "Sécurité",
  "security.twoFactor": "Authentification à Deux Facteurs",
  "security.enabled": "Activé",
  "security.disabled": "Désactivé",
  "security.enable2FA": "Activer 2FA",
  "security.disable": "Désactiver",
  "security.activeSessions": "Sessions Actives",
  "security.logoutAll": "Déconnecter partout",
  "security.lastUsed": "Dernière utilisation",
  "security.currentSession": "Actuelle",
  "security.loginHistory": "Historique de Connexion",
  "security.successfulLogin": "Connexion réussie",
  "security.failedLogin": "Tentative échouée",
  "security.setup2FA": "Configurer l\'Authentification à Deux Facteurs",
  "security.scanQR": "Scannez ce code QR avec votre application d\'authentification.",
  "security.secretKey": "Clé Secrète",
  "security.enterCode": "Entrez le code à 6 chiffres",
  "security.verify": "Vérifier et Activer",
  "security.cancel": "Annuler",
  "security.password": "Mot de passe",
  "security.done": "Terminé",
  "feedback.button": "Commentaires",
  "feedback.title": "Envoyer un Commentaire",
  "feedback.typeBug": "Bug",
  "feedback.typeFeature": "Fonctionnalité",
  "feedback.typeGeneral": "Général",
  "feedback.descPlaceholder": "Dites-nous ce qui s\'est passé...",
  "feedback.priorityLow": "Faible",
  "feedback.priorityMedium": "Moyen",
  "feedback.priorityHigh": "Élevé",
  "feedback.submit": "Envoyer",
  "feedback.thanks": "Merci ! Nous allons examiner cela.",
};

export default fr;
